import { SelectInput } from '@core/components/Select';
import { TableActionButton, TableActionContainer } from '@core/components/TableAction';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Divider, FormControlLabel, Grid, Radio, RadioGroup, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ClearAll } from '@material-ui/icons';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectCategoria from 'app/components/Select/SelectCategoria';
import SelectCliente from 'app/components/Select/SelectCliente';
import { FormikProvider } from 'formik';
import React, { useContext, useEffect } from 'react';
import { FaInfoCircle, FaPlus, FaSearch } from 'react-icons/fa';
import { ConciliacaoContext } from '../ConciliacaoContext';
import { VisualizacaoDespesaLista, VisualizacaoDespesaUnica } from '../visualizacao/VisualizacaoDespesa';
import { Receita, VisualizacaoReceitaLista } from '../visualizacao/VisualizacaoReceita';
import { FormLancamentoDespesa } from './FormularioLancamentoDespesa';

const useStyles = makeStyles(() => ({
  firstRadioOption: {
    paddingLeft: '1%',
  },
  lastRadioOption: {
    paddingRight: '1%',
  },
  customIcons: {
    fontSize: '16px',
  },
}));

export const FormLancamentoReceita = ({
  formik,
  exibirTitulo,
  exibirAcoes,
  handlerPesquisar,
  handlerLimparInformacoes,
  temPermissaoParaVisualizar,
  temPermissaoParaCadastrar,
  handlerLancarContaReceber,
}) => {
  const classes = useStyles();

  const _errors = {
    clienteReceita: (formik?.submitCount > 0 || formik?.touched?.clienteReceita) && formik?.errors?.clienteReceita,
    categoriaReceita:
      (formik?.submitCount > 0 || formik?.touched?.categoriaReceita) && formik?.errors?.categoriaReceita,
    valorReceita: (formik?.submitCount > 0 || formik?.touched?.valorReceita) && formik?.errors?.valorReceita,
    formaRecebimentoReceita:
      (formik?.submitCount > 0 || formik?.touched?.formaRecebimentoReceita) && formik?.errors?.formaRecebimentoReceita,
  };

  return (
    <>
      {exibirTitulo && (
        <div style={{ margin: '15px 0px' }}>
          <b>RECEITA</b>
        </div>
      )}
      <Grid container className="mt-8">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <SelectCliente
            id="clienteReceita"
            label="Cliente"
            onChange={formik.handleChange}
            value={formik.values?.clienteReceita}
            onBlur={formik.handleBlur}
            touched={!!_errors.clienteReceita}
            error={_errors.clienteReceita}
            required
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} className="mt-8">
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <SelectCategoria
            id="categoriaReceita"
            label="Categoria"
            value={formik.values?.categoriaReceita}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            maxLength={100}
            natureza="RECEITA"
            required
            touched={!!_errors.categoriaReceita}
            error={_errors.categoriaReceita}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <InputMonetario
            required
            id="valorReceita"
            label="Valor (R$)"
            fullWidth
            maximumValue={'999999999.99'}
            handleChange={formik.handleChange}
            value={formik.values?.valorReceita}
            onBlur={formik.handleBlur}
            touched={!!_errors.valorReceita}
            error={_errors.valorReceita}
            helperText={_errors.valorReceita} // O texto de validação do Yup só aparece com o helperText
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <SelectInput
            id="formaRecebimentoReceita"
            label="Forma de recebimento"
            required
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values?.formaRecebimentoReceita}
            error={_errors?.formaRecebimentoReceita}
            touched={!!_errors?.formaRecebimentoReceita}
            options={[
              { id: 'BOLETO', title: 'Boleto' },
              { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
              { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
              { id: 'CHEQUE', title: 'Cheque' },
              { id: 'TED_DOC', title: 'TED/DOC' },
              { id: 'DINHEIRO', title: 'Dinheiro' },
              { id: 'PIX', title: 'Pix' },
              { id: 'OUTRAS', title: 'Outras' },
            ]}
          />
        </Grid>
      </Grid>

      {exibirAcoes && (
        <Grid item xs={12} style={{ margin: '10px 0px', textAlign: 'end' }}>
          <TableActionContainer>
            {temPermissaoParaVisualizar && (
              <TableActionButton
                title="Pesquisar conta"
                icon={<FaSearch size={16} />}
                onClick={() => handlerPesquisar()}
              />
            )}
            {temPermissaoParaCadastrar && (
              <TableActionButton
                title="Lançar conta"
                icon={<FaPlus size={16} />}
                onClick={() => handlerLancarContaReceber()}
              />
            )}
            <TableActionButton
              title="Limpar informações"
              icon={<ClearAll size={12} className={classes.customIcons} />}
              onClick={() => handlerLimparInformacoes()}
            />
          </TableActionContainer>
        </Grid>
      )}
    </>
  );
};

const FormularioLancamentoReceita = ({
  index,
  formik,
  extrato,
  handlerPesquisarReceita,
  handlerPesquisarDespesa,
  handlerVisualizarReceita,
  handlerEditarReceita,
  handlerLimparInformacoesVisualizacao,
  handlerVisualizarDespesa,
  handlerEditarDespesa,
  handlerLancarContaReceber,
  handlerLancarContaPagar,
}) => {
  const [conciliacoes] = useContext(ConciliacaoContext).conciliacoes;
  const classes = useStyles();

  const tooltip =
    'Esta é uma sugestão do novo lançamento. Caso concorde, preencha os ' +
    'demais campos e clique em “Conciliar” para que uma nova conta a receber ' +
    'baixada seja criada. Caso não concorde, selecione outra ação.';

  const removerDespesa = (extrato) => {
    conciliacoes
      .filter((c) => c.id === extrato.id)
      .forEach((c) => {
        c.receitasDespesas = false;
        c.contaPagarList = undefined;
      });
  };

  const atualizarExtrato = (index) => {
    let conciliacao = conciliacoes[index];
    if (formik?.values?.tipoLancamento === 'RECEITAS_DESPESAS') {
      conciliacao.receitasDespesas = true;
      if (!conciliacao.contaPagarList || (conciliacao.contaPagarList && conciliacao.contaPagarList.length === 1)) {
        if (
          formik?.values?.fornecedorDespesa &&
          formik?.values?.categoriaDespesa &&
          (formik?.values?.valorDespesa || formik?.values?.valorDespesa >= 0) &&
          formik?.values?.formaPagamentoDespesa
        ) {
          conciliacao.contaPagarList = [
            {
              fornecedor: formik?.values?.fornecedorDespesa,
              categorias: [formik?.values?.categoriaDespesa],
              valor: formik?.values?.valorDespesa,
              formaPagamento: formik?.values?.formaPagamentoDespesa,
              numeroCheque: formik.values?.numeroChequeDespesa,
              formulario: true,
            },
          ];
        }
      }
    } else {
      conciliacao.receitasDespesas = false;
      conciliacao.contaPagarList = undefined;
    }
    if (!conciliacao.contaReceberList || (conciliacao.contaReceberList && conciliacao.contaReceberList.length === 1)) {
      if (
        formik?.values?.clienteReceita &&
        formik?.values?.categoriaReceita &&
        formik?.values?.valorReceita &&
        formik?.values?.formaRecebimentoReceita
      ) {
        conciliacao.contaReceberList = [
          {
            cliente: formik?.values?.clienteReceita,
            categorias: [formik?.values?.categoriaReceita],
            valor: formik?.values?.valorReceita,
            formaRecebimento: formik?.values?.formaRecebimentoReceita,
            formulario: true,
          },
        ];
      }
    }
  };

  const handlerLimparInformacoesReceita = () => {
    formik.setFieldValue('clienteReceita', undefined);
    formik.setFieldValue('categoriaReceita', undefined);
    formik.setFieldValue('formaRecebimentoReceita', undefined);
    formik.setFieldValue('valorReceita', extrato.valor);

    conciliacoes
      .filter((c) => c.id === extrato.id)
      .forEach((c) => {
        if (formik?.values?.tipoLancamento === 'RECEITAS_DESPESAS') {
          c.receitasDespesas = true;
        } else {
          c.receitasDespesas = false;
        }
        if (!c.contaReceberList || (c.contaReceberList && c.contaReceberList.length === 1)) {
          delete c.contaReceberList;
        }
      });
  };

  const handlerLimparInformacoesDespesa = () => {
    formik.setFieldValue('fornecedorDespesa', undefined);
    formik.setFieldValue('categoriaDespesa', undefined);
    formik.setFieldValue('valorDespesa', 0);
    formik.setFieldValue('formaRecebimentoReceita', undefined);
    formik.setFieldValue('formaPagamentoDespesa', undefined);
    formik.setFieldValue('numeroChequeDespesa', undefined);

    conciliacoes
      .filter((c) => c.id === extrato.id)
      .forEach((c) => {
        if (formik?.values?.tipoLancamento === 'RECEITAS_DESPESAS') {
          c.receitasDespesas = true;
          if (!c.contaPagarList || (c.contaPagarList && c.contaPagarList.length === 1)) {
            delete c.contaPagarList;
          }
        }
      });
  };

  const atualizar = (event) => {
    if (event.target.value === 'RECEITAS') {
      removerDespesa(extrato);
    }
    formik.handleChange(event);
  };

  const formikValues = formik?.values;
  useEffect(() => {
    atualizarExtrato(index);
    extrato.valorFormulario =
      formikValues?.tipoLancamento === 'RECEITAS'
        ? formikValues?.valorReceita
        : formikValues?.valorReceita - formikValues?.valorDespesa;
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikValues]);

  return (
    <>
      <FormikProvider value={formik}>
        <Grid container>
          <Grid item xs={10}>
            <RadioGroup
              row
              aria-label="position"
              id="tipoLancamento"
              name="tipoLancamento"
              value={formik?.values?.tipoLancamento}
              onChange={atualizar}
              defaultValue="RECEITAS"
            >
              <FormControlLabel
                value="RECEITAS"
                control={<Radio color="primary" />}
                label="Receitas"
                className={classes.firstRadioOption}
              />

              <FormControlLabel
                value="RECEITAS_DESPESAS"
                control={<Radio color="primary" />}
                label="Receitas e despesas"
              />
            </RadioGroup>
          </Grid>
          <Grid item xs={2} style={{ textAlign: 'end' }}>
            <Tooltip title={tooltip} placement="right-end">
              <button type="button" onClick={() => {}}>
                <FaInfoCircle size={18} style={{ color: '#f2994a' }} />
              </button>
            </Tooltip>
          </Grid>
        </Grid>
        {formik?.values?.tipoLancamento === 'RECEITAS' && <FormLancamentoReceita formik={formik} />}
        {formik?.values?.tipoLancamento === 'RECEITAS_DESPESAS' && (
          <>
            {extrato.contaReceberList &&
            extrato.contaReceberList.length === 1 &&
            !extrato.contaReceberList[0].formulario ? (
              <Receita
                contaReceber={extrato.contaReceberList[0]}
                exibirTitulo
                exibirAcoes
                handlerVisualizar={handlerVisualizarReceita}
                handlerEditar={handlerEditarReceita}
                handlerLimparInformacoes={handlerLimparInformacoesVisualizacao}
                temPermissaoParaVisualizar={permissaoUtils.contaReceber().visualizar}
                temPermissaoParaEditar={permissaoUtils.contaReceber().editar}
                temPermissaoParaCadastrar={permissaoUtils.contaReceber().cadastrar}
                handlerLancarContaReceber={handlerLancarContaReceber}
                handlerPesquisar={handlerPesquisarReceita}
              />
            ) : extrato.contaReceberList &&
              extrato.contaReceberList.length > 1 &&
              !extrato.contaReceberList[0].formulario ? (
              <VisualizacaoReceitaLista
                exibirAcoes
                exibirTitulo
                contaReceberList={extrato.contaReceberList}
                conciliado={extrato.conciliado}
                handlerEditar={handlerEditarReceita}
                handlerVisualizar={handlerVisualizarReceita}
                handlerLimparInformacoes={handlerLimparInformacoesVisualizacao}
                handlerLancarContaReceber={handlerLancarContaReceber}
                temPermissaoParaVisualizar={permissaoUtils.contaReceber().visualizar}
                temPermissaoParaEditar={permissaoUtils.contaReceber().editar}
                temPermissaoParaCadastrar={permissaoUtils.contaReceber().cadastrar}
                handlerPesquisar={handlerPesquisarReceita}
              />
            ) : (
              <FormLancamentoReceita
                formik={formik}
                exibirTitulo
                exibirAcoes
                handlerPesquisar={handlerPesquisarReceita}
                handlerLimparInformacoes={handlerLimparInformacoesReceita}
                temPermissaoParaVisualizar={permissaoUtils.contaReceber().visualizar}
                temPermissaoParaCadastrar={permissaoUtils.contaReceber().cadastrar}
                handlerLancarContaReceber={handlerLancarContaReceber}
              />
            )}
            <Divider style={{ margin: '20px 0px' }} />
            {extrato.contaPagarList && extrato.contaPagarList.length === 1 && !extrato.contaPagarList[0].formulario ? (
              <VisualizacaoDespesaUnica
                contaPagar={extrato.contaPagarList[0]}
                exibirTitulo
                exibirAcoes
                handlerEditar={handlerEditarDespesa}
                handlerVisualizar={handlerVisualizarDespesa}
                handlerLimparInformacoes={handlerLimparInformacoesVisualizacao}
                temPermissaoParaVisualizar={permissaoUtils.contaPagar().visualizar}
                temPermissaoParaEditar={permissaoUtils.contaPagar().editar}
                temPermissaoParaCadastrar={permissaoUtils.contaPagar().cadastrar}
                handlerLancarContaPagar={handlerLancarContaPagar}
                handlerPesquisar={handlerPesquisarDespesa}
              />
            ) : extrato.contaPagarList && extrato.contaPagarList.length > 1 && !extrato.contaPagarList[0].formulario ? (
              <VisualizacaoDespesaLista
                exibirTitulo
                exibirAcoes
                contaPagarList={extrato.contaPagarList}
                conciliado={extrato.conciliado}
                temPermissaoParaVisualizar={permissaoUtils.contaPagar().visualizar}
                temPermissaoParaEditar={permissaoUtils.contaPagar().editar}
                temPermissaoParaCadastrar={permissaoUtils.contaPagar().cadastrar}
                handlerVisualizar={handlerVisualizarDespesa}
                handlerEditar={handlerEditarDespesa}
                handlerLimparInformacoes={handlerLimparInformacoesVisualizacao}
                handlerLancarContaPagar={handlerLancarContaPagar}
                handlerPesquisar={handlerPesquisarDespesa}
              />
            ) : (
              <FormLancamentoDespesa
                formik={formik}
                exibirTitulo
                exibirAcoes
                handlerPesquisar={handlerPesquisarDespesa}
                handlerLimparInformacoes={handlerLimparInformacoesDespesa}
                temPermissaoParaVisualizar={permissaoUtils.contaPagar().visualizar}
                temPermissaoParaCadastrar={permissaoUtils.contaPagar().cadastrar}
                handlerLancarContaPagar={handlerLancarContaPagar}
              />
            )}
          </>
        )}
      </FormikProvider>
    </>
  );
};

export default FormularioLancamentoReceita;
